const sortArray = (strArray: string[]): string[] => {
  // Sort the tags in alphabetical order
  let sorted = strArray.sort();

  // Sorts the array with respect to case (Upperdcase/Lowercase) of the letter
  sorted = strArray.sort(caseInsensitiveComp);

  return sorted;
};

const caseInsensitiveComp = (strA: string, strB: string): number => {
  return strA.toLowerCase().localeCompare(strB.toLowerCase());
};

export default sortArray;
